import React from "react";
import {
	LAPORAN_JASA_MEDIS,
	LN_LAPORAN_ANTRIAN_JKN,
	LN_LAPORAN_INCOME,
	LN_LAPORAN_JADWAL_DOKTER,
	LN_LAPORAN_LOG_BRIDGING,
	LN_LAPORAN_REGISTRASI,
	LN_LAPORAN_SERVICE,
	LN_STATUS_SERVICE,
	LN_LAPORAN_JADWAL_OPERASI,
} from "App/constants";
import {
	LaporanAntrianJKNPage,
	LaporanIncome,
	LaporanJasaMedisPage,
	LaporanLogBridging,
	LaporanService,
	StatusService,
	LaporanJadwalDokterPage,
	LaporanRegistrasi,
	LaporanJadwalOperasiPage,
} from "../WrapperLazyExport";

export const menuLaporan = {
	[LN_LAPORAN_ANTRIAN_JKN]: <LaporanAntrianJKNPage />,
	[LN_LAPORAN_JADWAL_DOKTER]: <LaporanJadwalDokterPage />,
	[LN_LAPORAN_JADWAL_OPERASI]: <LaporanJadwalOperasiPage />,

	[LAPORAN_JASA_MEDIS]: <LaporanJasaMedisPage />,

	// Laporan Service Export
	[LN_LAPORAN_SERVICE]: <LaporanService />,
	[LN_STATUS_SERVICE]: <StatusService />,
	[LN_LAPORAN_LOG_BRIDGING]: <LaporanLogBridging />,
	// End Laporan Service Export

	// Laporan
	[LN_LAPORAN_INCOME]: <LaporanIncome />,
	// Laporan Registrasi
	[LN_LAPORAN_REGISTRASI]: <LaporanRegistrasi />,
	// End Laporan
};
